'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var SelectList = require('@narvar/nth-select-list');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var SelectList__default = /*#__PURE__*/_interopDefaultLegacy(SelectList);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-6j9cu7-0"
})(["text-align:center;display:flex;flex-direction:column;align-items:center;padding:1rem 0;gap:0.5rem;max-width:520px;"]);
const Header = styled__default["default"].div.withConfig({
  componentId: "sc-6j9cu7-1"
})(["font-weight:700;"]);
const Description = styled__default["default"].div.withConfig({
  componentId: "sc-6j9cu7-2"
})([""]);
const StyledSelectList = styled__default["default"](SelectList__default["default"]).withConfig({
  componentId: "sc-6j9cu7-3"
})(["margin:1.5rem 0;"]);
const Remarks = styled__default["default"].div.withConfig({
  componentId: "sc-6j9cu7-4"
})(["", ""], _ref => {
  let {
    theme
  } = _ref;
  return theme.captiontextDefaultNone;
});

exports.Description = Description;
exports.Header = Header;
exports.Remarks = Remarks;
exports.StyledSelectList = StyledSelectList;
exports.Wrapper = Wrapper;
